import { Flex, Loader, useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';

function ReviveEntrySubmittingScreen() {
  const { t } = useTranslation('contest');
  const theme = useMantineTheme();

  return (
    <Flex direction="column" align="center" justify="center" gap={theme.spacing.lg} mih={250}>
      <Loader size={48} />

      <Flex direction="column" align="center" gap={theme.spacing.sm}>
        <Title variant="headline-xl" color={theme.colors.gray2[7]}>
          {t('common.reviveEntryModal.submitting.title')}
        </Title>
        <Text variant="body-medium" color={theme.colors.gray2[5]} w={400} ta="center">
          {t('common.reviveEntryModal.submitting.text')}
        </Text>
      </Flex>
    </Flex>
  );
}

export default ReviveEntrySubmittingScreen;
